export default __webpack_public_path__ + "static/media/Image gallery element(2).1811d8b5.png";